import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';

import {
  ICostLayerChange,
  ICostLayerChangesAgCellParams,
} from '../../cost-layers.types';

@Component({
  selector: 'lum-cost-layer-changes-ag-cell-summary',
  templateUrl: './cost-layer-changes-ag-cell-summary.component.html',
  styleUrls: ['./cost-layer-changes-ag-cell-summary.component.scss'],
})
export class CostLayerChangesAgCellSummaryComponent
  implements ICellRendererAngularComp
{
  #params :ICostLayerChangesAgCellParams;

  change :ICostLayerChange;
  didInit :boolean = false;

  agInit(params :ICostLayerChangesAgCellParams) {
    this.#params = params;
    this.change = params?.data;
    this.didInit = true;
  }

  refresh(params :ICostLayerChangesAgCellParams) :boolean {
    this.#params = {
      ...this.#params,
      ...params,
    };

    return true;
  }
}
